module.exports = __webpack_public_path__ + "img/start-your-journey-graphics.814f2189.png";